export interface Permission {
  id: string;
  label: string;
  feature: string;
}

export interface Role {
  id: string;
  name: string;
  description: string;
  permissions: string[];
  isSystem: boolean;
  createdAt: any;
  updatedAt: any;
  createdBy: string;
}

export interface RoleInfo {
  id: string;
  displayName: string;
}

export interface AdUser {
  microsoftUserId: string;
  displayName: string;
  email?: string;
  roleId: string | null;
  roleDisplayName: string | null;
  hasSignedIn: boolean;
  firebaseUid?: string;
}

export const ALL_PERMISSIONS: Permission[] = [
  { id: 'members.read', label: 'permissions.perm.members-read', feature: 'permissions.feature.members' },
  { id: 'members.invite', label: 'permissions.perm.members-invite', feature: 'permissions.feature.members' },
  { id: 'members.manage', label: 'permissions.perm.members-manage', feature: 'permissions.feature.members' },
  { id: 'members.remove', label: 'permissions.perm.members-remove', feature: 'permissions.feature.members' },
  { id: 'settings.read', label: 'permissions.perm.settings-read', feature: 'permissions.feature.settings' },
  { id: 'settings.manage', label: 'permissions.perm.settings-manage', feature: 'permissions.feature.settings' },
  { id: 'permissions.read', label: 'permissions.perm.permissions-read', feature: 'permissions.feature.permissions' },
  { id: 'permissions.manage', label: 'permissions.perm.permissions-manage', feature: 'permissions.feature.permissions' },
  { id: 'plan.write', label: 'permissions.perm.plan-write', feature: 'permissions.feature.plan' },
  { id: 'plan.delete', label: 'permissions.perm.plan-delete', feature: 'permissions.feature.plan' },
];

export const PERMISSION_FEATURES = [...new Set(ALL_PERMISSIONS.map((p) => p.feature))];

/**
 * Default permission sets for system roles.
 * Used for seeding Firestore and as fallback when role docs don't exist yet.
 */
export const DEFAULT_ADMIN_PERMISSIONS = ['*'];

export const DEFAULT_MEMBER_PERMISSIONS = [
  'members.read',
  'settings.read',
  'permissions.read',
  'plan.write',
  'plan.delete',
];

export const SYSTEM_ROLE_DEFINITIONS: { id: string; name: string; description: string; permissions: string[] }[] = [
  { id: 'admin', name: 'Admin', description: 'Administrative access', permissions: DEFAULT_ADMIN_PERMISSIONS },
  { id: 'member', name: 'Member', description: 'Basic member access', permissions: DEFAULT_MEMBER_PERMISSIONS },
];
